import { render, staticRenderFns } from "./Dungeon.vue?vue&type=template&id=7f3a53e6&"
import script from "./Dungeon.vue?vue&type=script&lang=js&"
export * from "./Dungeon.vue?vue&type=script&lang=js&"
import style0 from "./Dungeon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports